module.exports = __webpack_public_path__ + "img/2.ab831d06.jpg";